import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { CheckRow } from '@/module/auth/sign-up/SignUpDetail/TermsSection';
import { Checkbox } from '@/ui/components/checkbox';
import { confirmDialog } from '@/ui_v3';
import { ProfileContainer } from '../share/UserProfile/ProfileWidget';
import { type ProfileEditFormData } from './schema';
const MarketingSubCheckbox = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    control,
    setValue
  } = useFormContext<ProfileEditFormData>();
  const userType = useWatch({
    control,
    name: 'userType'
  });
  const emailMarketingAgreement = useWatch({
    control,
    name: 'emailMarketingAgreement'
  });
  const phoneMarketingAgreement = useWatch({
    control,
    name: 'phoneMarketingAgreement'
  });
  const isStudent = userType === 'student';
  return <div className={'flex items-center gap-xs'} data-sentry-component="MarketingSubCheckbox" data-sentry-source-file="MarketingAgreementSection.tsx">
      <label htmlFor={'emailMarketingAgreement'} className={'flex shrink-0 cursor-pointer items-center gap-xs text-center text-body-md-semibold text-default'}>
        <Checkbox id={'emailMarketingAgreement'} checked={emailMarketingAgreement} onCheckedChange={b => setValue('emailMarketingAgreement', Boolean(b), {
        shouldDirty: true
      })} data-sentry-element="Checkbox" data-sentry-source-file="MarketingAgreementSection.tsx" />
        {t('account.signup.email')}
      </label>

      {!isStudent && <label htmlFor={'phoneMarketingAgreement'} className={'flex shrink-0 cursor-pointer items-center gap-xs text-center text-body-md-semibold text-default'}>
          <Checkbox id={'phoneMarketingAgreement'} checked={phoneMarketingAgreement} onCheckedChange={b => setValue('phoneMarketingAgreement', Boolean(b), {
        shouldDirty: true
      })} />
          {t('account.signup.phone')}
        </label>}
    </div>;
};
export const MarketingAgreementSection = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    watch,
    setValue
  } = useFormContext<ProfileEditFormData>();
  const userType = watch('userType');
  const isStudent = userType === 'student';
  const marketingConsentChecked = watch('emailMarketingAgreement') || watch('phoneMarketingAgreement') ? true : false;
  const setOptionalCheck = (_b: boolean) => {
    setValue('emailMarketingAgreement', _b, {
      shouldDirty: true
    });
    // STUDENT가 아닌 경우에만 phoneMarketingAgreement 설정
    if (!isStudent) {
      setValue('phoneMarketingAgreement', _b, {
        shouldDirty: true
      });
    }
  };
  const handleCheckClick = async () => {
    // 체크 해제하려는 경우 (현재 체크된 상태)
    if (marketingConsentChecked) {
      const shouldKeep = await confirmDialog.openAsync({
        header: {
          title: t('profileEdit.marketingChange.title')
        },
        body: t('profileEdit.marketingChange.body'),
        cancelText: t('profileEdit.marketingChange.cancelText'),
        confirmText: t('profileEdit.marketingChange.confirmText'),
        shouldCloseOnDimClick: false
      });

      // "유지하기"를 선택한 경우 아무것도 하지 않음
      if (shouldKeep) {
        return;
      }

      // "해제하기"를 선택한 경우 체크 해제
      setOptionalCheck(false);
    } else {
      // 체크하려는 경우 (현재 체크 해제된 상태)
      setOptionalCheck(true);
    }
  };
  return <ProfileContainer className="max-w-[640px] rounded-xl p-lg mobile-lg:p-2xl" data-sentry-element="ProfileContainer" data-sentry-component="MarketingAgreementSection" data-sentry-source-file="MarketingAgreementSection.tsx">
      <CheckRow alignSelf={true} checked={marketingConsentChecked} onClickCheck={handleCheckClick} actionButton={<MarketingSubCheckbox />} forceWrap={true} text={<div className={'flex flex-col'}>
            <span>
              <span className={'text-assistive'}>
                ({t('account.signup.select')})
              </span>
              &nbsp;
              {t('account.terms.marketingAgreement')}
            </span>
            <span className={'text-caption-lg-regular text-assistive'}>
              {t('account.terms.marketingBenefitsInfo')}
            </span>
          </div>} data-sentry-element="CheckRow" data-sentry-source-file="MarketingAgreementSection.tsx" />
    </ProfileContainer>;
};